import React from "react";
import { imageBaseUrl } from "../utils/variables";
import { Button } from "../button";
import "./style.scss";
var NotFound = function (props) {
    return (React.createElement("div", { className: "not-found-container" },
        React.createElement(Button, { buttonText: props.buttonText, onClick: props.onClickHandler }),
        React.createElement("img", { src: props.notFoundImg, alt: "not-found" })));
};
NotFound.defaultProps = {
    buttonText: "Go to Homepage",
    notFoundImg: "".concat(imageBaseUrl, "/img/myshubhlife/page-not-found.png"),
};
export default NotFound;
//# sourceMappingURL=index.js.map